import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import {
  sendStkPush,
  resetPaymentServerStatus,
} from "../../redux/actions/paymentActions";

const StkPushModal = ({
  open,
  onClose,
  invoiceId,
  totalAmount,
  amountPaid,
  defaultPhone,
}) => {
  const dispatch = useDispatch();

  // Strictly using Redux state
  const { loadingStkPush, serverStatus } = useSelector(
    (state) => state.payment,
  );

  const [phone, setPhone] = useState(defaultPhone || "");

  const balanceDue = Number(totalAmount || 0) - Number(amountPaid || 0);

  // Listen for success from Redux to close the modal
  useEffect(() => {
    if (
      serverStatus?.operation === "stk.push" &&
      serverStatus?.status === 200
    ) {
      dispatch(resetPaymentServerStatus());
      onClose();
    }
  }, [serverStatus, dispatch, onClose]);

  const handleSubmit = () => {
    if (!phone || !invoiceId) return;

    const payload = {
      invoiceId,
      phoneNumber: phone,
    };

    dispatch(sendStkPush(payload));
  };

  return (
    <Dialog
      open={open}
      onClose={loadingStkPush ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Send M-Pesa STK Push</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={3} mt={1}>
          The customer will receive a prompt on their phone to enter their
          M-Pesa PIN. Once paid, use the "Link Payment" button to attach it to
          this receipt.
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Phone Number"
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="e.g. 2547XXXXXXXX"
            disabled={loadingStkPush}
          />
          <TextField
            label="Amount (Balance Due)"
            type="number"
            fullWidth
            value={balanceDue > 0 ? balanceDue : 0}
            disabled // Cannot edit, driven strictly by Invoice Balance
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={loadingStkPush}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          disabled={loadingStkPush || !phone}
        >
          {loadingStkPush ? "Sending..." : "Send Prompt"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StkPushModal;
